import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class CommonPortionServices extends Resource {
    async getPortionInformation(labId, caseId, sampleId, portionId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}`)
        return response.data
    }

    async findByLabel(laboratoryId, portionLabel) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/samples/portions/${portionLabel}/findByLabel`)
        return response.data
    }

    async getTracking(laboratoryId, caseId, sampleId, portionId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/tracking`)
        return response.data
    }

    async getPortionsByCaseId(laboratoryId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/portions`)
        return response.data
    }

    async search(params) {
        const response = await this.axios.get('/common/portions/search', { params })
        return response.data
    }

    async getNextPortionCodes(laboratoryId, params) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/samples/portions/getNextPortionCodes`, { params })
        return response.data
    }

    async exportTo(laboratoryId, caseId, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/common/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/export`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
}

export default new CommonPortionServices()
